import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { LogoutButton, UserInfo } from '@qapline/api';
import { IPageProps, Page, Separator } from '@qapline/ui';
import { config } from 'config';
import { LanguageSwitch } from 'core/translation';
import { useHistory } from 'hooks/useHistory';
import { useIsAdmin } from 'hooks/useIsAdmin';

import styles from './AuthenticatedLayout.module.scss';

export const AuthenticatedLayout = () => {
    const { t } = useTranslation('admin', { keyPrefix: 'nav' });
    const isAdmin = useIsAdmin();
    useHistory();

    const navRoutes: IPageProps['headerProps']['routes'] = [
        { title: t('dashboard'), url: config.routes.dashboard.dashboard },
        { title: t('commissions'), url: config.routes.commission.overview },
        { title: t('carriers'), url: config.routes.carrier.overview },
        { title: t('customers'), url: config.routes.customer.overview },
        { title: t('invoicing'), url: config.routes.invoice.overview },
        { title: t('offers'), url: config.routes.offer.overview },
    ];
    if (isAdmin) {
        navRoutes.push({ title: t('expenses'), url: config.routes.expense.overview });
    }

    return (
        <Page
            headerProps={{
                routes: navRoutes,
                rightSlot: (
                    <>
                        <LanguageSwitch />
                        <Separator orientation="vertical" className={styles.separator} />
                        <UserInfo userProfileUrl={''} />
                        <LogoutButton />
                    </>
                ),
            }}
        >
            <Outlet />
        </Page>
    );
};
